// eslint-disable-next-line import/no-extraneous-dependencies
import 'angular-ui-bootstrap/src/stackedMap/stackedMap';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'angular-ui-bootstrap/src/modal/modal';
import './mobile-modal.css';

import windowMobileTemplate from './windowMobile.template.jade';

export default angular.module('cian.modal.adapter', ['ui.bootstrap.stackedMap', 'ui.bootstrap.modal']).run([
  '$templateCache',
  'deviceService',
  ($templateCache, deviceService) => {
    if (deviceService.isMobile) {
      $templateCache.put('uib/template/modal/window.html', windowMobileTemplate);
    }
  },
]).name;
